// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/iview-loader/index.js??ref--5!./dicgrid.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("d696132e", content, true);


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/styles/dicgrid.css
// module id = 5
// module chunks = 0